// extracted by mini-css-extract-plugin
export default {"titleText":"VerifyCard_titleText__Ai90Q","infoWrapper":"VerifyCard_infoWrapper__aomi0","listContainer":"VerifyCard_listContainer__ekXmg"};